import { useTu } from "@src/appV2/i18n/useTu";
import { Box, Link } from "@mui/material";
import { SUPPORT_WEBFORM_URL } from "@src/appV2/ContactCBHInfo/constants";
import { Text } from "@src/appV2/redesign/components/Text";
import { type ReactNode } from "react";
const clipboardWordmark = `${import.meta.env.BASE_URL}assets/clipboard-wordmark-brown.png`;

interface MobileLoginLayoutProps {
  banner?: ReactNode;
  children: ReactNode;
}

export function MobileLoginLayout({ banner, children }: MobileLoginLayoutProps) {
  const { tu } = useTu("login");

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.baseDark",
        overflow: "auto",
        paddingX: 5,
        paddingTop: "max(24px, env(safe-area-inset-top))",
        paddingBottom: "max(20px, env(safe-area-inset-bottom))",
      }}
    >
      {banner && <Box sx={{ flexShrink: 0, width: "100%", marginBottom: 3 }}>{banner}</Box>}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: 5,
        }}
      >
        <Box
          component="img"
          src={clipboardWordmark}
          alt="Clipboard"
          sx={{ height: 70, width: "auto", marginBottom: 5 }}
        />

        {children}
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          gap: 4,
          alignItems: "center",
          justifyContent: "center",
          whiteSpace: "nowrap",
        }}
      >
        <Text variant="body2" sx={{ color: "base.muted" }}>
          {`Clipboard Health \u00A9${new Date().getFullYear()}`}
        </Text>
        <Link
          href={SUPPORT_WEBFORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ fontSize: "0.875rem", color: "primary.main" }}
        >
          {tu("Contact Us")}
        </Link>
      </Box>
    </Box>
  );
}
